module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Tools/Compass-12f4c39ef84dd67a1c0437acd56c59e7918b46fda6708224fee54d68210bbc7e.svg";